import React from 'react';
import { useTranslation } from 'react-i18next';
import './MeloAttributeSection.less';
import Button from '../../../../components/envago/Button/Button';
import Icon from '../../../../components/envago/Icon/Icon';
import LabeledList from '../../../../components/envago/LabeledList/LabeledList';
import OptionalLabel from '../../../../components/envago/OptionalLabel/OptionalLabel';
import { MeloAttributeItem } from '../../../../redux/jobs/jobs.types';
import { getMeloAttributeType } from './meloAttributeTypes';
import { formatDate } from '../../../../helper/DateHelper';

interface MeloAttributeSectionProps {
    entries: MeloAttributeItem[];
    onEdit: (item: MeloAttributeItem) => void;
}

const MeloAttributeSection = ({ entries, onEdit }: MeloAttributeSectionProps) => {
    const { t } = useTranslation();

    if (entries.length === 0) {
        return null;
    }

    return (
        <div role={'group'} aria-label={t('jobs.details.meloAttribute.sectionAria')}>
            <hr className={'my-4 border-gray-400'} />
            <div className={'mb-2 text-sm text-gray-500'}>{t('jobs.details.meloAttribute.sectionTitle')}</div>
            <LabeledList>
                {entries.map((item) => {
                    const config = getMeloAttributeType(item.entry.type);
                    return (
                        <OptionalLabel
                            key={item.id}
                            label={formatDate(item.lastModified ?? item.created)}
                            labelClassName={'pl-3'}
                            className={'flex flex-row items-center gap-3 pl-3 lg:pl-0 melo-attribute-entry'}
                        >
                            <span>{config.renderValue(item.entry)}</span>
                            <Button
                                iconButton
                                ghost
                                small
                                onClick={() => onEdit(item)}
                                aria={{ 'aria-label': t('jobs.details.meloAttribute.editAria') }}
                            >
                                <Icon path={Icon.Path.mdiPencil} aria={{ 'aria-hidden': true }} />
                            </Button>
                        </OptionalLabel>
                    );
                })}
            </LabeledList>
        </div>
    );
};

export default MeloAttributeSection;
